import { default as React, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import SearchOption from "./searchOption";
import Collapsible from 'react-collapsible';
import { FilterOption } from "core/pages/pageList";
const s = require("./search.module.scss");

export const default_tsos: FilterOption[] = [
    { title: "50Hertz", value: "10XDE-VE-TRANSMK" },
    { title: "Amprion", value: "10XDE-RWENET---W" },
    { title: "Apg", value: "10XAT-APG------Z" },
    { title: "Ceps", value: "10XCZ-CEPS-GRIDE" },
    { title: "Eles", value: "10XSI-ELES-----1" },
    { title: "Elia", value: "10X1001A1001A094" },
    { title: "Hops", value: "10XHR-HEP-OPS--A" },
    { title: "Mavir", value: "10X1001A1001A329" },
    { title: "Pse", value: "10XPL-TSO------P" },
    { title: "Rte", value: "10XFR-RTE------Q" },
    { title: "Seps", value: "10XSK-SEPS-GRIDB" },
    { title: "TennetBv", value: "10X1001A1001A361" },
    { title: "TransnetBw", value: "10XDE-ENBW--TNGX" },
    { title: "TennetGmbh", value: "10XDE-EON-NETZ-C" },
    { title: "Transelectrica", value: "10XRO-TEL------2" }
];

export const default_hubs: FilterOption[] = [
    { title: "AT", value: "10YAT-APG------L" },
    { title: "BE", value: "10YBE----------2" },
    { title: "CZ", value: "10YCZ-CEPS-----N" },
    { title: "DE", value: "10YCB-GERMANY--8" },
    { title: "FR", value: "10YFR-RTE------C" },
    { title: "HU", value: "10YHU-MAVIR----U" },
    { title: "HR", value: "10YHR-HEP------M" },
    { title: "NL", value: "10YNL----------L" },
    { title: "PL", value: "10YPL-AREA-----S" },
    { title: "RO", value: "10YRO-TEL------P" },
    { title: "SI", value: "10YSI-ELES-----O" },
    { title: "SK", value: "10YSK-SEPS-----K" }

];

interface OwnState {
    search: (params: any) => void;
    isLoading: boolean;
    filter: { totalRows: number, totalRowsWithFilter: number, maxRows: number };
    searchFields?: SearchField[];
}
export interface SearchField {
    title: string;
    parameter: string;
    type: string;
    options?: Option[];
    defaultValue?: any;
}
export interface Option {
    title: string;
    value: any;
}

type SearchProps = OwnState & WithTranslation;

const SearchField = ({ search, isLoading, filter, searchFields, t }: SearchProps) => {

    const [searchOptions, setSearchOptions] = useState({});
    const [reset, setReset] = useState(false);

    const setOptionValue = (option: string, value: any) => {
        setSearchOptions({
            ...searchOptions,
            [option]: value
        });
    }

    const resetFilter = () => {
        (document.getElementById("searchForm") as HTMLFormElement).reset();
        setReset(true);
        setSearchOptions({});
        search({});
    }

    return (
        searchFields == undefined || searchFields == null || searchFields.length == 0 ? <></>
            :
            <Collapsible
                onClosing={() => (document.getElementsByClassName('Collapsible__contentOuter')[0] as HTMLElement).style.overflow = 'hidden'}
                onOpen={() => (document.getElementsByClassName('Collapsible__contentOuter')[0] as HTMLElement).style.overflow = 'inherit'}
                trigger={
                    <div className={s.collapsible}>
                        <span className={s.searchLabel}>{t("common:search")}</span>
                        <i className={s.collapsibleArrow}></i>
                    </div>
                }>
                <div className="inputlabel" style={{ display: "inline-block" }}>
                    <form id="searchForm" onSubmit={e => e.preventDefault()}>
                        <table><tbody>
                            {
                                searchFields.map(field =>
                                    <SearchOption
                                        key={field.parameter}
                                        option={field}
                                        reset={reset}
                                        setReset={setReset}
                                        setOptionValue={setOptionValue} />)
                            }
                            <tr style={{ borderTop: '1px solid #757575' }}>
                                <td>
                                    <button style={{ marginBottom: "3px" }} onClick={() => resetFilter()}>
                                        {t("common:reset").toString()}
                                    </button>
                                    <br />
                                    <button onClick={() => { search(searchOptions) }}>
                                        {t("common:search")}
                                    </button>
                                </td>
                                <td style={{ paddingTop: '5px' }}>
                                    <div style={{ display: "inline-block", marginLeft: "20px" }}>
                                        <div className="inputlabel" style={{ margin: 0 }}>{isLoading ? t("common:loading") : t("common:totalWithoutFilter") + ": " + filter.totalRows}</div>
                                        <div className="inputlabel" style={{ margin: 0 }}>{isLoading ? "" : t("common:totalWithFilter") + ": " + filter.totalRowsWithFilter}</div>
                                        <div className="inputlabel" style={{ margin: 0 }}>{isLoading ? "" : t("common:displayedRows") + ": " + Math.min(filter.maxRows, filter.totalRowsWithFilter)}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                    </form>
                </div>
            </Collapsible>
    );
};

export default withTranslation()(SearchField);
